import type { CSSProperties } from 'react';
import CaretLeftIconSvg from '../../assets/icons/caret_left.svg?react';

export interface IconProps {
    size?: number | string;
    className?: string;
    style?: CSSProperties;
    onClick?: () => void;
}

const CaretLeftIcon: React.FC<IconProps> = ({ size = 16, className = '', style = {}, onClick }) => {
    const iconStyle: CSSProperties = {
        width: typeof size === 'number' ? `${size}px` : size,
        height: typeof size === 'number' ? `${size}px` : size,
        display: 'inline-block',
        fill: 'currentColor',
        ...style,
    };

    return <CaretLeftIconSvg className={className} style={iconStyle} onClick={onClick} />;
};

export default CaretLeftIcon;
